import React, { useEffect, useState } from 'react';
import logo from '../../assets/images/oto-web-icon.png';
import StickyMenu from '../../lib/StickyMenu';
import RegisterModal from '../Modals/RegisterModal';
import Navigation from '../Navigation';

function HeaderHomeFour({ action }) {
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        StickyMenu();
    }, []);
    return (
        <>
            {showModal && (
                <RegisterModal show={showModal} onRequestClose={() => setShowModal(false)} />
            )}

            <header className="appie-header-area appie-header-4-area appie-sticky">
                <div className="container">
                    <div className="header-nav-box header-nav-box-5">
                        <div className="row align-items-center">
                            <div className="col-lg-2 col-md-4 col-sm-5 col-6 order-1 order-sm-1">
                                <div className="appie-logo-box">
                                    <a href="/">
                                        <img src={logo} alt="OTO Logo" title="OTO Software Suite" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-1 col-sm-1 order-3 order-sm-2">
                                <div className="appie-header-main-menu d-none d-lg-flex justify-content-center">
                                    <Navigation />
                                </div>
                            </div>
                            <div className="col-lg-2  col-md-7 col-sm-6 col-6 order-2 order-sm-3">
                                <div className="appie-btn-box text-right">
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShowModal(true);
                                        }}
                                        className="main-btn ml-30"
                                        href="#"
                                    >
                                        Sign Up Now !
                                    </a>
                                    <div
                                        onClick={(e) => action(e)}
                                        className="toggle-btn ml-30 canvas_open d-lg-none d-block"
                                    >
                                        <i className="fal fa-bars"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
}

export default HeaderHomeFour;
